export const debounce = <T>(callback: (args: T) => void, delay: number) => {
  let timer: NodeJS.Timeout | undefined = undefined;
  return (args: T) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => callback(args), delay);
  };
};

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));
